import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { typographStyles } from '../../theme-constants/typograhy-overrides';




export const docUploadStyles = makeStyles((theme) => ({
    docUploadContainer: {
        '& .MuiDropzoneArea': {
            '&-root': {
                marginBottom: theme.spacing(1),
                background: tcsmColors.greySeven,
                color: tcsmColors.greyTwo,
                '& svg': {
                    fill: tcsmColors.greyTwo,
                },
            },
            '&-active, &-invalid': {
                borderColor: tcsmColors.darkBlue,

            },
        },
        '& .MuiChip-root': {
            maxWidth: '15rem',
        },
        '& .MuiTypography-h5': typographStyles.h4,

        '& .MuiChip-label': {
            textDecoration: 'underline',
            color: tcsmColors.blue,
        },
        '& .MuiChip-deleteIcon': {
            color: tcsmColors.greyThree,
        },
        '& .MuiDropzonePreviewList': {
            '&-root': {
                marginTop: theme.spacing(.25),
            },
            '&-imageContainer': {
                textAlign: 'left',
            },
            '&-removeButton': {
                position: 'relative',
                top: '0',
            },
        },
        '& .required-indicator': {
            color: tcsmColors.red,
        },
    },



}));



